import {
  Button,
  ButtonDesigns,
  ButtonTypes,
  getFontCss,
  Popup,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React from 'react'
import { useSelector } from 'react-redux'
import AppName from 'src/components/AppName/AppName'
import SvgGooglePlayStore from 'src/components/Svgs/SvgGooglePlayStore'
import SvgIosAppStore from 'src/components/Svgs/SvgIosAppStore'
import { useBackgroundDispatch } from 'src/hooks'
import { useTranslate } from 'src/localization/Trns'
import { createSetIsMobileWebPopupOpen } from 'src/redux/actions/app.actions'
import {
  selectBrandAppStoreLink,
  selectBrandGooglePlayStoreLink,
} from 'src/redux/selectors/session.selectors'
import { css } from 'styled-components'

interface MobileWebPopupProps {
  signupAndJoin?: boolean
}

const MobileWebPopup: React.FC<MobileWebPopupProps> = (props) => {
  const translate = useTranslate()

  const brandAppStoreLink = useSelector(selectBrandAppStoreLink)
  const brandGooglePlayStoreLink = useSelector(selectBrandGooglePlayStoreLink)

  const dispatch = useBackgroundDispatch()

  return (
    <Popup noPadding>
      <div
        css={css`
          padding: 30px;
          max-width: 600px;
        `}
      >
        <div
          css={css`
            ${getFontCss(
              20,
              themeConstants.colors.font_primary,
              styleConstants.fontFamilies.medium,
            )};
            margin-bottom: 20px;
          `}
        >
          {translate('${appName} is not optimized for mobile web browsers', {
            appName: <AppName />,
          })}
        </div>
        <div
          css={css`
            ${getFontCss(
              16,
              themeConstants.colors.font_primary,
              styleConstants.fontFamilies.regular,
            )};
            margin-bottom: 20px;
          `}
        >
          <div
            css={css`
              margin-bottom: 20px;
            `}
          >
            {translate(
              'For an optimal ${appName} experience, please find links below to download our iOS or Android app.',
              {
                appName: <AppName />,
              },
            )}
          </div>
          {props?.signupAndJoin &&
            translate(
              'Once the app is downloaded, access your invitation using the email you received earlier!',
            )}
        </div>
        <div
          css={css`
            display: flex;
            gap: 8px;
            justify-content: center;
          `}
        >
          <a href={brandAppStoreLink} target={'_blank'} rel={'noreferrer'}>
            <SvgIosAppStore />
          </a>
          <a
            href={brandGooglePlayStoreLink}
            target={'_blank'}
            rel={'noreferrer'}
          >
            <SvgGooglePlayStore />
          </a>
        </div>
      </div>
      <div
        css={css`
          background-color: ${styleConstants.colors.gray_lightest};
          padding: 30px;
          border-radius: 0px 0px 10px 10px;
          border-top: 1px solid ${styleConstants.colors.gray_medium};
        `}
      >
        <Button
          design={ButtonDesigns.designCta}
          type={ButtonTypes.submit}
          big
          onClick={(): void => {
            dispatch(createSetIsMobileWebPopupOpen(false))
          }}
          text={translate('Dismiss and continue on web')}
          css={css`
            width: 100%;
          `}
        />
      </div>
    </Popup>
  )
}

export default MobileWebPopup
